import { Dispatch } from "react";
import { connect } from "react-redux";

import TransactionSummary from "./transactionSummary";
import { AppState } from "../../core/reducers/rootReducer";
import * as paymentActionTypes from "../../core/actionTypes/paymentSummaryActionTypes";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { getAccountBalance, getPaymentSummary, getTransactionSummaryConsentReset } from "../../core/actionCreators/paymentSummaryActionCreators";

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    paymentDetails: state.paymentSummary,
    isLoading: state.isLoading[paymentActionTypes.GET_ACCOUNT_BALANCE] || state.isLoading[paymentActionTypes.GET_PAYMENT_DETAILS],
    isAuthenticated: isUserLoggedIn(txnId),
    error: state.error[paymentActionTypes.GET_ACCOUNT_BALANCE] || state.error[paymentActionTypes.GET_PAYMENT_DETAILS],
    partnerData: state.auth,
    transactionDetails: state.transactionDetails,
  };
};


const mapDispatchToProps = (dispatch: Dispatch<paymentActionTypes.PaymentAction>) => ({
  getAccountBalance: () => {
    dispatch(getAccountBalance());
  },
  getPaymentSummaryDetails: () => {
    dispatch(getPaymentSummary());
  },
  resetTransactionSummary: () => {
    dispatch(getTransactionSummaryConsentReset())
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionSummary);
